import BaseModel from "../core/BaseModel";
export default class InstructVideoModel extends BaseModel {
  constructor() {
    super(
      {
        name: "instruct_video",
        tableName: "instruct_video",
        label: "Quản Lý Video Hướng Dẫn",
        display_key: "name",
      },
      {
        stt: { 
          name: "stt", 
          label: "STT",
          class: 'center', 
          computed: (data, index) => {
            data.stt = index + 1;
          }
        },
        id: {
          name: "id",
          type: "Number",
          label: "ID",
          primaryKey: true,
          display: false,
        },

        title: {
          name: "title",
          type: "String",
          label: "Tiêu đề video",
        },

        url: {
          name: "url",
          type: "String",
          label: "Link video",
        },

        ordinal: {
          name: "ordinal",
          type: "Number",
          label: "Thứ tự hiển thị",
          class: "center"
        },

        active: {
          name: "active",
          type: "Boolean",
          label: "Hiển thị",
          class: "center"
        },

        updated_at: {
          name: "updated_at",
          type: "Datetime",
          label: "Cập nhật cuối"
        },

        deleted: {
          name: "deleted",
          label: "Xóa",
          type: "Checkbox",
          display: false,
        },
      }
    );
  }
}
